module.exports = __webpack_public_path__ + "img/svg/calendar.9f525fe0c47a345e3cdb77f14fc73f1a.svg";